import { render, staticRenderFns } from "./ReportViewPagosCuerpoTecnico.vue?vue&type=template&id=3c4ac888&"
import script from "./ReportViewPagosCuerpoTecnico.vue?vue&type=script&lang=js&"
export * from "./ReportViewPagosCuerpoTecnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
